<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
	<div class="sidebar-next-right-block">
		<div class="partner-right-block-body">
			<p-scrollPanel [style]="{height: 'calc(100vh - 310px)'}">
				<div class="mos-header flex">
					<div class="mos-header__title">Payout Account</div>
					<!--<button (click)="changedShowMerchantAddPaymentSideBarEmit(true)" class="btn-darkblue" pButton label="Add Payout Account" style="width: 181px; height: 45px; margin-left: auto"></button>-->
				</div>

				<div *ngIf="loading" style="text-align: center; padding: 30px;">
					<p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
									   fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
				</div>

				<div class="flex flex-row" *ngIf="!loading">
					<div class="mos-add-store-block" *ngIf="payments.length === 0">
						<img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
						<div class="mos-add-store__add">Add new</div>
					</div>

					<div class="mos-stores-block" *ngFor="let payment of payments" style="margin-left: 0;">
						<div class="mos-btn-rounded-block">
							<p-button icon="pi pi-ellipsis-v" styleClass="p-button-rounded p-button-text" (click)="op.toggle($event)"></p-button>
							<p-overlayPanel #op [style]="{width: '130px'}">
								<ng-template pTemplate>
									<div class="mos-op-link">Remove</div>
								</ng-template>
							</p-overlayPanel>
						</div>
						<div (click)="handleShowPaymentDetailSideBar(payment)">
							<div class="mos-stores-img-response">
								<img class="mos-stores-img" src="{{payment.ImageUrl}}" />
							</div>

							<div class="mos-stores-name">{{payment.AccountName}}</div>
							<div class="mos-stores-address-details">Account number: {{payment.AccountNumber}}</div>
						</div>
					</div>
				</div>
			</p-scrollPanel>
		</div>

		<merchant-create-payment [_showMerchantAddPaymentSideBar]="showMerchantAddPaymentSideBar"
								 [_merchantId]="0"
								 (changedShowMerchantAddPaymentSideBarEmit)="changedShowMerchantAddPaymentSideBarEmit($event)"
								 *ngIf="showMerchantAddPaymentSideBar"></merchant-create-payment>
		<partner-payout-account-details [showMerchantDetailPaymentSideBar]="showMerchantDetailPaymentSideBar"
										[payment]="selectedPayment"
										[onHide]="handleHidePaymentDetailSideBar"></partner-payout-account-details>

		<p-toast position="top-right"></p-toast>
	</div>
</div>
